import Checkbox from "./checkbox.component";

export default Checkbox;
